import { OpportunityPositionItem } from '../../../models/opportunity.model';
import { PositionFormRow } from '../components/PositionEditor';

export const positionToFormRow = (p: OpportunityPositionItem): PositionFormRow => ({
  title: p.title,
  description: p.description ?? '',
  headCount: p.headCount,
  sortOrder: p.sortOrder,
  technologies: p.technologies.map((t) => ({
    technologyCanonicalId: t.canonicalId,
    canonicalName: t.canonicalName,
    requiredLevel: t.requiredLevel,
    requiredWeight: t.requiredWeight,
  })),
  certifications: p.certifications.map((c) => ({
    mode: c.certificationFamilyId != null ? ('family' as const) : ('cert' as const),
    certificateId: c.certificateId,
    certificateTitle: c.certificateTitle,
    certificationFamilyId: c.certificationFamilyId,
    certificationFamilyName: c.certificationFamilyName,
  })),
  languages: p.languages.map((l) => ({
    languageId: l.languageId,
    languageNativeName: l.languageNativeName,
    requiredProficiencyId: l.requiredProficiencyId,
    requiredProficiencyName: l.requiredProficiencyName,
    requiredWeight: l.requiredWeight,
  })),
});

export const emptyPositionRow = (sortOrder: number): PositionFormRow => ({
  title: '',
  description: '',
  headCount: 1,
  sortOrder,
  technologies: [],
  certifications: [],
  languages: [],
});
